// @ts-check
import { graphql } from 'gatsby';
import React from 'react';
import { ConstructBasicElement, GetCopyFromJson } from '~/contentstack/rendering';

import './LedgerSection.scss';

export const query = graphql`
	fragment LedgerFragment on Ozk_content_blockModular_blocksCopyContent {
		ledger {
			ledger_title {
				json
			}
			items {
				left_text {
					json
				}
				right_text {
					json
				}
			}
		}
	}
`;

/**
 * @typedef LedgerItem
 * @property {import('~/templates/CSTypes').CSJRTE} left_text
 * @property {import('~/templates/CSTypes').CSJRTE} right_text

 * @typedef LedgerOptions
 * @property {LedgerItem[]} items
 * @property {import('~/templates/CSTypes').CSJRTE} ledger_title

 * @param {{ options: LedgerOptions }} props
 */
const LedgerBlock = ({ options }) => {
	const plainOverride = ConstructBasicElement('p', 'fragment');

	const heading = GetCopyFromJson(options.ledger_title, plainOverride);

	return (
		<div className="ledger-section">
			{!!heading && <h5 className="heading">{heading}</h5>}

			{options.items.map((entry, i) => {
				const left = GetCopyFromJson(entry.left_text, plainOverride);
				const right = GetCopyFromJson(entry.right_text, plainOverride);

				return (
					<div className="ledger-item" key={i}>
						<div className="left">{left}</div>
						<div className="right">{right}</div>
					</div>
				);
			})}
		</div>
	);
};

export default LedgerBlock;
